const CHECK_USER_SESSION_ASYNC = 'user/CHECK_USER_SESSION_ASYNC';
const SIGN_IN_ASYNC = 'user/SIGN_IN_ASYNC';
const SIGN_UP_ASYNC = 'user/SIGN_UP_ASYNC';
const SIGN_OUT = 'user/SIGN_OUT';
const FETCH_SELECTED_USER_ASYNC = 'user/FETCH_SELECTED_USER_ASYNC';

export const USER_ACTION_TYPES = {
  CHECK_USER_SESSION_ASYNC,
  SIGN_IN_ASYNC,
  SIGN_UP_ASYNC,
  SIGN_OUT,
  FETCH_SELECTED_USER_ASYNC,
};
